import { render, staticRenderFns } from "./SelectCombo.vue?vue&type=template&id=13164965&"
import script from "./SelectCombo.vue?vue&type=script&lang=js&"
export * from "./SelectCombo.vue?vue&type=script&lang=js&"
import style0 from "./SelectCombo.vue?vue&type=style&index=0&id=13164965&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports